/**
 * Canonical TanStack query-key factory for cohort reads. Use these keys
 * from any feature lib so cache state stays unified across the app.
 */
export const cohortQueryKeys = {
  all: ['cohorts'] as const,
  profile: (cohortId: string) => [...cohortQueryKeys.all, 'profile', cohortId] as const,
  version: (cohortVersionId: string) =>
    [...cohortQueryKeys.all, 'version', cohortVersionId] as const,
  list: (projectId: string) => [...cohortQueryKeys.all, 'list', projectId] as const,
  usage: (cohortId: string) => [...cohortQueryKeys.all, 'usage', cohortId] as const,
  // Generic asset-staleness read, shared by cohort and analytical-dataset
  // version detail pages — see useAssetStalenessQuery.
  assetStaleness: (kind: string, id: string) =>
    [...cohortQueryKeys.all, 'assetStaleness', kind, id] as const,
  // Prefix matching every assetStaleness(kind, id) entry for a given kind,
  // regardless of id — use to bulk-invalidate after an action that can
  // affect any number of assets of that kind (e.g. cohort processing can
  // stale any analytical dataset built on top of it).
  assetStalenessKind: (kind: string) => [...cohortQueryKeys.all, 'assetStaleness', kind] as const,
};
